import styled from "styled-components";
import colors from "styles/colors";

export const Body = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
`;

export const Home = styled.div`
  display: flex;
  padding: 52px;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;

  @media (max-width: 400px) {
    padding: 24px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
`;

export const WelcomeText = styled.div`
  display: flex;
  padding: 24px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  .company_manager_name{
    flex: 1 0 0;
    color: ${colors.brightGray[950]};
    font-family: Poppins;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 123.5%;
    letter-spacing: 0.25px;

    span {
      color: ${colors.brightGray[950]};
      font-family: Poppins;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: 123.5%;
      letter-spacing: 0.25px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  row-gap: 24px;
  column-gap: 24px;
  align-self: stretch;
  flex-wrap: wrap;

  @media (max-width: 753px) {
    justify-content: center;
  }

`;